import { UserIsAuthenticated, UserHasValidPassword, UserHasScope } from 'containers/authContainers'

import CreateStudyConfigurationContainer from '../../CreateStudy/containers/CreateStudyConfigurationContainer'
import { actions, fetchStudyVersionList } from '../../CreateStudy/modules/CreateStudy'
import { actions as paymentActions } from '../routes/Payments/modules/Payments'

export default store => ({
  getComponent(nextState, cb) {
    const ensure = require.ensure || ((dependencies, callback) => callback())
    ensure(
      [],
      () => {
        const { params, location } = nextState
        const { studyID } = params

        const currentStudyId = store.getState().study.currentStudy?.id
        if (studyID != null && String(currentStudyId ?? '') !== String(studyID)) {
          store.dispatch(actions.fetchStudy(studyID)).then(study => {
            const hasStudy = study && typeof study === 'object' && Object.keys(study).length
            if (hasStudy && !location.pathname.endsWith('/payments')) {
              if (study?.config?.super_gems) {
                store.dispatch(paymentActions.fetchPendingGiftcards(params.studyID, false))
              } else {
                store.dispatch(paymentActions.fetchPayments(params.studyID, false))
              }
              if (study?.config?.study_promotion) {
                store.dispatch(fetchStudyVersionList(studyID))
              }
            }
            cb(
              null,
              UserIsAuthenticated(
                UserHasValidPassword(
                  UserHasScope(['rsc'], CreateStudyConfigurationContainer, false, studyID, null, study),
                ),
              ),
            )
          })
        } else {
          cb(
            null,
            UserIsAuthenticated(
              UserHasValidPassword(UserHasScope(['rsc'], CreateStudyConfigurationContainer, false, studyID)),
            ),
          )
        }
      },
      'create',
    )
  },
})
